import React from 'react'

export const kansasSetupVars = {
  siteId: 'kansas',
  pathPrefix: '/ks',
  menuHeader: "Discover Kansas's Solution for:",
  appUrl: 'https://ks.headed2.com',
  logoImg: '/images/assets/kansas/horizontal/dark.svg',
  headerTitle: `The Kansas CareerExplorer is a system designed for Kansas`
}
